<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading full-character-formatting" id="dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For those of you who are there for all the randomness that falls out of my head and exits through my mouth.</p>
<p class="subsq dedication-content">You know who you are.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?450e0bdf